import { render, staticRenderFns } from "./PayBannerAd.vue?vue&type=template&id=58af8a12&scoped=true"
import script from "./PayBannerAd.vue?vue&type=script&lang=js"
export * from "./PayBannerAd.vue?vue&type=script&lang=js"
import style0 from "./PayBannerAd.vue?vue&type=style&index=0&id=58af8a12&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58af8a12",
  null
  
)

export default component.exports